module.exports = __webpack_public_path__ + "img/videocard.23783ce6.svg";